// extracted by mini-css-extract-plugin
module.exports = {"tag_popup_container":"TagPopup_tag_popup_container__1jkaq","option_container":"TagPopup_option_container__1lO1g","contact_tag":"TagPopup_contact_tag__24erl"};